import { render, staticRenderFns } from "./RetentionTouchpointAssignModal.vue?vue&type=template&id=011f8615&"
import script from "./RetentionTouchpointAssignModal.vue?vue&type=script&lang=js&"
export * from "./RetentionTouchpointAssignModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports